import { useCreateStore } from '@/entities/create';
import { useModalStore } from '@/shared/lib/store/model/modal.store';
import { useRouter } from '@tanstack/react-router';

export const CreateExitPopup = ({ routeUrl }: { routeUrl: any }) => {
    const router = useRouter();
    const { closeModal } = useModalStore();
    const { setState: createSetState } = useCreateStore();

    const handleRoute = () => {
        if (routeUrl === 'data') {
            createSetState('type', 'data');
        } else if (routeUrl == 'setMode') {
            createSetState('type', 'setMode');
        } else if (routeUrl === 'back') {
            router.history.back();
        } else {
            router.navigate(routeUrl);
        }
        closeModal('create_exit_popup');
    };
    return (
        <div className="ki-dim ttukttak">
            <div className="pos-center">
                <div className="pop_wrap pop_size_small new_data_popup_wrap research_notice">
                    <div className="modal_header">
                        <div className="title">안내</div>
                    </div>
                    <div className="pop_contents data_delet_popcont">
                        <div className="base-box box-type">
                            <p className="txt_red icon_mark notice2">
                                <i></i>저장하지 않은 자료는 사라집니다.
                            </p>
                            <p>편집 중인 자료를 저장하지 않고 나가시겠습니까?</p>
                        </div>
                        <div className="bt_wrap cont-mt4">
                            <button
                                className="btn btn-default line_gray1 pop_cancle2"
                                onClick={() => closeModal('create_exit_popup')}
                            >
                                취소
                            </button>
                            <button
                                className="btn btn-default blue page_next"
                                onClick={handleRoute}
                            >
                                이동
                            </button>
                        </div>
                    </div>
                    <button
                        type="button"
                        className="btn-x btn-x-white"
                        onClick={() => closeModal('create_exit_popup')}
                    >
                        <span className="sr-only">팝업 닫기</span>
                    </button>
                </div>
            </div>
        </div>
    );
};
